import React from 'react';

import { fundTableTypes, explixitContractFundTypes } from './actions'


const initialState = {
    isFetching: false,
}


export function fundTable(state = initialState, action) {

    switch(action.type) {

        case fundTableTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case fundTableTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data
            return state

        case explixitContractFundTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case explixitContractFundTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.explicit = action.data
            return state


        default:
            return state
    }
}